export const hasPermission = (module, action) => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");

    // Admin has full access
    if (user?.roleName?.toLowerCase() === "admin") {
      return true;
    }

    const permissions = JSON.parse(
      localStorage.getItem("permissions") || "{}"
    );

    return permissions?.[module]?.includes(action) || false;
  } catch {
    return false;
  }
};